import {
  LOAN_APPLICATION_FETCH_SUCCESS,
  BUILD_ASSET,
  UPDATE_ASSETS_FAILURE,
  UPDATE_COMMITMENTS_SUCCESS,
  LOAN_APPLICATION_USER_GOBACK_SUCCESS,
  LOAN_APPLICATION_USER_GOTO_SUCCESS,
} from './../../actions/types'

import { filterAssets } from './index';

const allCashIds = (state = [], {type, payload}) => {
  switch (type) {
    case LOAN_APPLICATION_FETCH_SUCCESS:
      if ( payload.applicationFlow.assets !== undefined ) {
        return Object.keys(filterAssets(payload.applicationFlow.assets, 'deposit'))
      } else {
        return state
      }
    case BUILD_ASSET:
      if (payload.data.assetType == 'deposit') {
        return [...new Set([...state, payload.key])]
      } else {
        return state
      }
    case UPDATE_COMMITMENTS_SUCCESS:
      if ( payload.assets !== undefined ) {
        return Object.keys(filterAssets(payload.assets, 'deposit'))
      } else {
        return state
      }
    case UPDATE_ASSETS_FAILURE:
      return Object.keys(filterAssets(payload.entities, 'deposit')) || []
    case LOAN_APPLICATION_USER_GOTO_SUCCESS:
    case LOAN_APPLICATION_USER_GOBACK_SUCCESS:
      if (payload.assets !== undefined) {
        return Object.keys(filterAssets(payload.assets, 'deposit')) || []
      } else {
        return state
      }
    default:
      return state;
  }
}

export default allCashIds;
